import react from 'react'
import {FC} from 'react'
import {numberWithCommas} from '../../../../../../../_metronic/helpers'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'

type props = {
  getSumNetPrice: () => number
}

const InvoiceNetPrice: FC<props> = ({getSumNetPrice}) => {
  return (
    <div className='border border-dashed p-5 border-primary rounded bg-light-primary'>
      <div className='text-center fs-2'>
        <FieldHelpLabel label='مجموع صورتحساب' helpKey='header.tbill' />:
        <div className='text-primary fw-bolder fs-2x ms-2'>
          {numberWithCommas(getSumNetPrice())}
          ریال
        </div>
      </div>
    </div>
  )
}

export {InvoiceNetPrice}
